import React, { useState } from 'react';
import { Form, Button, Col, Row, Dropdown, DropdownButton } from 'react-bootstrap';
import { Link } from "react-router-dom";


const SalesAnalysisForm = () => {
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedProcedures, setSelectedProcedures] = useState([]);
  const [includeClosed, setIncludeClosed] = useState(false);
  const [includeInactive, setIncludeInactive] = useState(false);
  const [byAttributes, setByAttributes] = useState(false);
  const [format, setFormat] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
  };

  // Inline styling
  const containerStyle = {
    maxWidth: '700px',
    padding: '20px',
    borderTop: '5px solid #007bff',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#f8f9fa',
    
  };

  const controlStyle = {
    borderRadius: '0.25rem',
    borderColor: '#ced4da',
  };

  const dropdownStyle = {
    width: '100%',
    marginBottom: '10px',
  };

  return (
    <>
      <h2 className="text-left mb-4" style={{ color: 'black' }}>Parameters</h2>
      <Form onSubmit={handleSubmit} style={containerStyle}>

        <Form.Group as={Row} controlId="formReportParameters">
          <Form.Label column sm={4}>
            Accounts
          </Form.Label>
          <Col sm={8}>
            <DropdownButton id="dropdown-accounts" title="Select accounts" style={dropdownStyle}>
              {/* Replace the options below with dynamic content as needed */}
              <Dropdown.Item onClick={() => setSelectedAccounts([...selectedAccounts, '144545'])}>2ingis s.a.</Dropdown.Item>
              <Dropdown.Item onClick={() => setSelectedAccounts([...selectedAccounts, '71159'])}>ALL SAINTS DENTAL</Dropdown.Item>
              {/* Add more options here */}
            </DropdownButton>
            <Form.Check
              type="checkbox"
              label="Include Closed"
              checked={includeClosed}
              onChange={() => setIncludeClosed(!includeClosed)}
              style={{ marginTop: '10px' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formAccountTags">
          <Form.Label column sm={4}>
            Account Tags
          </Form.Label>
          <Col sm={8}>
            <DropdownButton id="dropdown-tags" title="Select tags" style={dropdownStyle}>
              {/* Replace the options below with dynamic content as needed */}
              <Dropdown.Item onClick={() => setSelectedTags([...selectedTags, 'a-practices'])}>a-practices</Dropdown.Item>
              <Dropdown.Item onClick={() => setSelectedTags([...selectedTags, 'bhandal'])}>bhandal</Dropdown.Item>
              {/* Add more options here */}
            </DropdownButton>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formProcedure">
          <Form.Label column sm={4}>
            Procedures
          </Form.Label>
          <Col sm={8}>
            <Form.Check
              type="checkbox"
              label="Inactive Selectable?"
              checked={includeInactive}
              onChange={() => setIncludeInactive(!includeInactive)}
              style={{ marginTop: '10px' }}
            />
            <DropdownButton id="dropdown-procedures" title="Select procedures" style={dropdownStyle}>
              {/* Replace the options below with dynamic content as needed */}
              <Dropdown.Item onClick={() => setSelectedProcedures([...selectedProcedures, '316'])}>1-7 ALIGNERS (DUAL ARCH)</Dropdown.Item>
              <Dropdown.Item onClick={() => setSelectedProcedures([...selectedProcedures, '404'])}>3D PRINTED MODELS</Dropdown.Item>
              {/* Add more options here */}
            </DropdownButton>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formOptions">
          <Form.Label column sm={4}>
            Options
          </Form.Label>
          <Col sm={8}>
            <Form.Check
              type="checkbox"
              label="Base report on Attributes"
              checked={byAttributes}
              onChange={() => setByAttributes(!byAttributes)}
              style={{ marginTop: '10px' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formFormat">
          <Form.Label column sm={4}>
            Format <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              as="select"
              value={format}
              onChange={(e) => setFormat(e.target.value)}
              style={controlStyle}
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </Form.Control>
          </Col>
        </Form.Group>
<Form.Group as={Row}>
         <Col sm={{ span: 8, offset: 4 }}>
           <Link to="/Addsaleprocedure">
             <Button
               id="pay-per-task-submit"
               type="button"
               variant="primary"
               className="w-100 mt-2"
               style={{
                 backgroundColor: '#004aad',
                 borderColor: '#004aad',
                 marginTop: '10px',
               }}
             >
               Run
             </Button>
           </Link>
         </Col>
        </Form.Group>
                </Form>
    </>
  );
};

export default SalesAnalysisForm;
